export const typesOfBody = [
    { label: "Select Body Type", value: "" },
    { label: "Flat", value: "Flat" },
    { label: "Open", value: "Open" },
    { label: "Full Covered", value: "Full Covered" },
    { label: "Half Covered", value: "Half Covered" },
];